<template>
  <v-card class="pa-2 text-center" flat tile>
    <span v-html="Articulo[0].ContentMayor"></span>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    computed: {
      ...mapState(["Articulo"]),
    },
  };
</script>

<style></style>
